'use client'
import { FC } from 'react'

import { ModalComponent } from '@/app/shared/components/modals/modal'
import { ITypeSite } from '@/app/shared/store/layout.store'
import useModal from '@/app/shared/store/modals.store'

interface IModalWrapperProps {
  typeSite: ITypeSite | null
}

const ModalWrapperComponent: FC<IModalWrapperProps> = ({ typeSite }) => {
  const { activeModals } = useModal()

  return (
    <div>
      {activeModals.map((modalEL, index) => (
        <ModalComponent
          key={`${modalEL.component?.name}-${index}`}
          typeSite={typeSite}
          {...modalEL}
        ></ModalComponent>
      ))}
    </div>
  )
}

export default ModalWrapperComponent
